import styled, { captureProps, ThemeContext } from "@kaggle/styled-components";
import { Icon as MaterialIcon } from "@rmwc/icon";
import * as React from "react";
import { getButtonRoleProps } from "../_utils/getButtonRoleProps";
import { TextEmphasis } from "../Typography/Typography";
import { iconColors } from "./iconColors";
import { IconOption } from "./IconOption";
// tslint:disable-next-line: no-var-requires
require("@rmwc/icon/icon.css");

export const KaggleIcon = styled(MaterialIcon).withConfig(
  captureProps("iconTheme") as any
)<{
  iconTheme?: any;
  sizevalue?: string;
  verticalalign?: string;
  emphasis?: TextEmphasis;
  color?: string;
}>`
  && {
    color: ${p => p.color || iconColors[p.theme.name][p.emphasis || "high"]};
    font-size: ${p => p.sizevalue};
    vertical-align: ${p => p.verticalalign};
    user-select: none;
  }
`;

export type IconSize =
  | "xxsmall"
  | "xsmall"
  | "small"
  | "medium"
  | "large"
  | "xlarge"
  | "inline";

export interface IconProps {
  className?: string;
  color?: string;
  emphasis?: TextEmphasis;
  icon: IconOption | React.ReactNode;
  onClick?: (event: React.MouseEvent) => void;
  size?: IconSize;
  style?: React.CSSProperties;
  title?: string;
}

const sizeMap = {
  xxsmall: "12px",
  xsmall: "18px",
  small: "20px",
  medium: "24px",
  large: "36px",
  xlarge: "48px",
  inline: "1.125em",
};

export const Icon: React.FC<IconProps> = props => {
  const { className, color, emphasis, icon, onClick, style, title } = props;
  const theme = React.useContext(ThemeContext);
  const iconTheme = iconColors[theme.name];

  const size = props.size || "medium";

  const sizevalue: string = sizeMap[size] || size;

  const buttonProps = onClick ? getButtonRoleProps() : {};
  return (
    <KaggleIcon
      className={className}
      color={color}
      emphasis={emphasis}
      iconTheme={iconTheme}
      icon={icon}
      onClick={onClick}
      sizevalue={sizevalue}
      style={style}
      title={title}
      {...buttonProps}
      verticalalign={props.size === "inline" ? "-0.125em" : undefined}
    />
  );
};
